import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';

import { CustomValidators } from 'ng2-validation';

import { AuthService } from '../../seguranca/auth.service';
import { Senha } from 'src/app/shared/model/senha.model ';
import { ToastrService } from 'ngx-toastr';

@Component({templateUrl: './nova-senha.component.html', styleUrls: ['./nova-senha.component.scss']})
export class NovaSenhaComponent  implements OnInit {

  constructor(private authService: AuthService, private router: Router,
          private activatedRoute: ActivatedRoute, private toast: ToastrService) { }

  form: UntypedFormGroup;

  tokenURL: string;
  newPassword: any;

  // Flag para exibir o conteudo da página
  shouldShowResetSenha = false;

  ngOnInit(): void {

    // Remover Token do localStorage.
    localStorage.removeItem('token');

      // inscrever nos parâmetros de rota, toda a vez que ele mudar mesmo que o componente tenha sido carregado, uma ação será executada.
      this.activatedRoute.params.subscribe(params => {
        // Pegar o token da URL caso seja alteração de senha.
        const tokenURL = this.activatedRoute.snapshot.params['token'];
        if (tokenURL) {
          this.validarToken(tokenURL);
        }
      });

      // Construir o formulário.
      const password = new UntypedFormControl('', Validators.required);
      const passwordConfirmation = new UntypedFormControl('', CustomValidators.equalTo(password));

      this.form = new UntypedFormGroup({
        password: password,
        passwordConfirmation: passwordConfirmation
      });
  }

  /**
   * Método responsável por validar o token passado na URL.
   * @param tokenURL identificador do token
   */
  private validarToken(tokenURL: string) {
    this.authService.getNovaSenha(tokenURL).subscribe(
      () => {
          this.tokenURL = tokenURL;
          this.shouldShowResetSenha = true;
      },
      (responseError) => {
        if (responseError instanceof HttpErrorResponse) {
          if (responseError.status === 404 || responseError.status === 400) {
            this.router.navigate(['/not-found']);
          } else if (responseError.status === 403) {
            this.router.navigate(['/nao-autorizado']);
          } else {
            this.toast.error('Ocorreu um erro ao processar a sua solicitação');
            this.router.navigate(['/']);
          }
        }
      }
    );
  }

  // Método responsável por realizar a requisição para resetar a senha do usuário.
  gerarNovaSenha() {
    const senha = new Senha();
    senha.novaSenha = this.form.get('password').value;

    this.authService.gerarNovaSenha(this.tokenURL, senha).subscribe(
          () => {
            this.toast.success('Senha redefinida com sucesso!');
            this.router.navigate(['/']);
          },
          responseError => this.toast.error('Ocorreu um erro ao processar a sua solicitação'),
      );
  }
}
